if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        if (cartNotification) {
          cartNotification.setActiveElement(this.openedBy);
        }

        this.modalContent.innerHTML = '';

        if (preventFocus) {
          this.openedBy = null;
        }

        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');

        opener
          .querySelector('.loading__spinner')
          ?.classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(
              responseText,
              'text/html'
            );

            const productElement =
              responseHTML.querySelector('product-info');

            this.preprocessHTML(productElement);

            HTMLUpdateUtility.setInnerHTML(
              this.modalContent,
              productElement.outerHTML
            );

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) {
              window.ProductModel.loadShopifyXR();
            }

            this.modalContent
              .querySelector('product-component')
              ?.dispatchViewEvent?.();

            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');

            opener
              .querySelector('.loading__spinner')
              ?.classList.add('hidden');
          });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (
            classApplied.startsWith('color-') ||
            classApplied === 'gradient'
          ) {
            this.modalContent.classList.add(classApplied);
          }
        });

        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability =
          productElement.querySelector('pickup-availability');

        if (pickupAvailability) {
          pickupAvailability.remove();
        }

        const productModal =
          productElement.querySelector('product-modal');

        if (productModal) {
          productModal.remove();
        }

        const modalDialog =
          productElement.querySelectorAll('modal-dialog');

        if (modalDialog) {
          modalDialog.forEach((modal) => modal.remove());
        }
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;

        productElement.innerHTML =
          productElement.innerHTML.replaceAll(oldId, newId);

        Array.from(productElement.attributes).forEach(
          (attribute) => {
            if (attribute.value.includes(oldId)) {
              productElement.setAttribute(
                attribute.name,
                attribute.value.replace(oldId, newId)
              );
            }
          }
        );

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList =
          productElement.querySelector('[id^="Slider-Gallery"]');

        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');

        galleryList
          .querySelectorAll('[id^="Slide-"]')
          .forEach((li) =>
            li.setAttribute('role', 'presentation')
          );
      }

      updateImageSizes(productElement) {
        const product =
          productElement.querySelector('.product');

        const desktopColumns =
          product?.classList.contains('product--columns');

        if (!desktopColumns) return;

        const mediaImages =
          product.querySelectorAll('.product__media img');

        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes =
            mediaImageSizes.replace('715px', '605px');
        } else if (
          product.classList.contains('product--small')
        ) {
          mediaImageSizes =
            mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) =>
          img.setAttribute('sizes', mediaImageSizes)
        );
      }
    }
  );
}


/* =========================================================
   AMIRA LABEL — QUICK BUY VARIANT UI
   COLOUR = IMAGE CAROUSEL
   SIZE = DROPDOWN
   ========================================================= */

(() => {
  const enhanceQuickBuyVariants = (root) => {
    if (!root) return;

    root
      .querySelectorAll('fieldset.product-form__input')
      .forEach((fieldset) => {
        const legend = fieldset.querySelector('legend');

        const optionName =
          (legend?.textContent || '')
            .trim()
            .toLowerCase();

        if (/^(colour|color)$/.test(optionName)) {
          buildColourCarousel(fieldset);
        }

        if (optionName === 'size') {
          buildSizeDropdown(fieldset);
        }
      });
  };


  /* =======================================================
     COLOUR IMAGE CAROUSEL
     ======================================================= */

  const buildColourCarousel = (fieldset) => {
    if (
      fieldset.dataset.qaColourReady === 'true'
    ) {
      return;
    }

    const radios = Array.from(
      fieldset.querySelectorAll(
        'input[type="radio"]'
      )
    );

    if (!radios.length) return;

    const imageRadios = radios.filter(
      (radio) => radio.dataset.variantImage
    );

    if (!imageRadios.length) return;

    fieldset.dataset.qaColourReady = 'true';
    fieldset.classList.add(
      'qa-colour-fieldset'
    );

    const carousel =
      document.createElement('div');

    carousel.className =
      'qa-colour-carousel';


    /* LEFT ARROW */

    const prev =
      document.createElement('button');

    prev.type = 'button';

    prev.className =
      'qa-colour-arrow qa-colour-arrow--prev';

    prev.setAttribute(
      'aria-label',
      'Previous colours'
    );

    prev.textContent = '‹';


    /* TRACK */

    const track =
      document.createElement('div');

    track.className =
      'qa-colour-track';


    /* RIGHT ARROW */

    const next =
      document.createElement('button');

    next.type = 'button';

    next.className =
      'qa-colour-arrow qa-colour-arrow--next';

    next.setAttribute(
      'aria-label',
      'Next colours'
    );

    next.textContent = '›';


    /* BUILD EACH COLOUR IMAGE */

    radios.forEach((radio) => {
      const label =
        fieldset.querySelector(
          `label[for="${CSS.escape(
            radio.id
          )}"]`
        );

      if (!label) return;

      const item =
        document.createElement('div');

      item.className =
        'qa-colour-item';

      const imageUrl =
        radio.dataset.variantImage;

      if (imageUrl) {
        label.classList.add(
          'qa-colour-image-label'
        );

        label.textContent = '';

        const img =
          document.createElement('img');

        img.src = imageUrl;
        img.alt = radio.value;
        img.loading = 'lazy';

        label.appendChild(img);

        const name =
          document.createElement('span');

        name.className =
          'visually-hidden';

        name.textContent =
          radio.value;

        label.appendChild(name);
      }

      item.appendChild(radio);
      item.appendChild(label);

      track.appendChild(item);
    });


    carousel.append(
      prev,
      track,
      next
    );

    fieldset.appendChild(carousel);


    /* CONTROL ARROWS */

    const updateArrows = () => {
      const overflow =
        track.scrollWidth >
        track.clientWidth + 2;

      prev.hidden = !overflow;
      next.hidden = !overflow;

      if (!overflow) return;

      prev.disabled =
        track.scrollLeft <= 2;

      next.disabled =
        track.scrollLeft +
          track.clientWidth >=
        track.scrollWidth - 2;
    };


    const scrollAmount = () => {
      const first =
        track.querySelector(
          '.qa-colour-item'
        );

      if (!first) {
        return track.clientWidth;
      }

      return (
        first
          .getBoundingClientRect()
          .width *
          4 +
        24
      );
    };


    prev.addEventListener(
      'click',
      () => {
        track.scrollBy({
          left: -scrollAmount(),
          behavior: 'smooth'
        });
      }
    );


    next.addEventListener(
      'click',
      () => {
        track.scrollBy({
          left: scrollAmount(),
          behavior: 'smooth'
        });
      }
    );


    track.addEventListener(
      'scroll',
      updateArrows,
      {
        passive: true
      }
    );


    window.addEventListener(
      'resize',
      updateArrows,
      {
        passive: true
      }
    );


    requestAnimationFrame(
      updateArrows
    );
  };


  /* =======================================================
     SIZE DROPDOWN
     ======================================================= */

  const buildSizeDropdown = (fieldset) => {
    if (
      fieldset.dataset.qaSizeReady === 'true'
    ) {
      return;
    }

    const radios = Array.from(
      fieldset.querySelectorAll(
        'input[type="radio"]'
      )
    );

    if (!radios.length) return;

    fieldset.dataset.qaSizeReady =
      'true';

    fieldset.classList.add(
      'qa-size-fieldset'
    );


    const wrap =
      document.createElement('div');

    wrap.className =
      'qa-size-select-wrap';


    const select =
      document.createElement('select');

    select.className =
      'qa-size-select';

    select.setAttribute(
      'aria-label',
      'Size'
    );


    /* IMPORTANT FIX:
       Use radio.value only.
       This prevents Shopify's hidden
       "Variant sold out or unavailable"
       message from appearing.
    */

    radios.forEach((radio) => {
      const option =
        document.createElement('option');

      option.value =
        radio.value;

      option.textContent =
        radio.value;

      option.disabled =
        radio.disabled ||
        radio.classList.contains(
          'disabled'
        );

      option.selected =
        radio.checked;

      select.appendChild(option);
    });


    /* SELECT -> SHOPIFY RADIO */

    select.addEventListener(
      'change',
      () => {
        const radio =
          radios.find(
            (item) =>
              item.value ===
              select.value
          );

        if (
          !radio ||
          radio.disabled
        ) {
          return;
        }

        radio.click();
      }
    );


    /* SHOPIFY RADIO -> SELECT */

    radios.forEach((radio) => {
      radio.addEventListener(
        'change',
        () => {
          if (radio.checked) {
            select.value =
              radio.value;
          }
        }
      );
    });


    wrap.appendChild(select);
    fieldset.appendChild(wrap);
  };


  /* =======================================================
     RUN INSIDE QUICK BUY MODALS
     ======================================================= */

  const runForModal = (modal) => {
    const info =
      modal.querySelector(
        '[id^="QuickAddInfo-"]'
      );

    if (!info) return;

    const apply = () =>
      enhanceQuickBuyVariants(info);

    apply();


    const observer =
      new MutationObserver(() => {
        apply();
      });


    observer.observe(info, {
      childList: true,
      subtree: true
    });
  };


  /* EXISTING MODALS */

  document
    .querySelectorAll(
      'quick-add-modal'
    )
    .forEach(runForModal);


  /* NEWLY LOADED MODALS */

  const pageObserver =
    new MutationObserver(() => {
      document
        .querySelectorAll(
          'quick-add-modal'
        )
        .forEach((modal) => {
          if (
            modal.dataset
              .qaVariantObserver ===
            'true'
          ) {
            return;
          }

          modal.dataset
            .qaVariantObserver =
            'true';

          runForModal(modal);
        });
    });


  pageObserver.observe(
    document.documentElement,
    {
      childList: true,
      subtree: true
    }
  );
})();